// AI Configuration
export const AI_CONFIG = {
  XAI_API_KEY: 'xai-gjBcYWHDqXAJDnqJGpUZ4OmKWuCkS6MuyXbfIClRNuLPpk0o3xtYsFwxaMwP7FkCPLb0QzLhgeJ9EhWG',
  MODEL: 'grok-2-latest'
};

export const isConfigured = {
  xai: true
};